import styled from 'styled-components';

export const StyledOrders = styled.section`
  ${({ theme }) => theme.mixins.views}
`;
